module.exports = __webpack_public_path__ + "img/shutterstock_387318658.9ab02c27.png";